import { MODULE_LINK_TYPE, MT_MODULES } from '../constants';
export const ADMIN = {
  [MODULE_LINK_TYPE.BUILD]: (moduleId: string, seriesId: string) =>
    `/ui/coaching/${MT_MODULES.TASK_EVALUATION_COACHING}/admin/${seriesId}/${moduleId}/build`,
  [MODULE_LINK_TYPE.INVITE_TRACK]: (moduleId: string, seriesId: string) =>
    `/ui/coaching/${MT_MODULES.TASK_EVALUATION_COACHING}/admin/${seriesId}/${moduleId}/invite-track`,
  [MODULE_LINK_TYPE.ANALYTICS]: (moduleId: string, seriesId: string, moduleName: string) =>
    `modules/${moduleId}/mission/task_evaluation_coaching/overview?gameType=task_evaluation_coaching&inSeries=${seriesId}&name=${moduleName}`,
};

export const LEARNER = {};
